import { Result } from './Result';
export class Code {
    constructor(
        public code: number[] = [1, 2, 3, 4]
    ) {

    }
    public static fromData(data: any) {
        if (!data) return;
        let o = new Code(
            data.code
        )
        return o;
    }
    public checkNumber(codeToTest: number[]): Result {
        const r = new Result(0, 0, [...codeToTest]);
        for (let pos = 0; pos < this.code.length; pos++) {
            let found = codeToTest.indexOf(this.code[pos]);
            if (found < 0) {
                continue;
            } else {
                if (found == pos) {
                    r.ok++
                } else {

                    r.regular++;
                }
            }
        }
        return r;
    }
}

